import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { get } from 'lodash';

import {
  Card,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  FirstPage as FirstPageIcon,
  KeyboardArrowLeft as ArrowLeftIcon,
  KeyboardArrowRight as ArrowRightIcon,
  LastPage as LastPageIcon,
} from '@material-ui/icons';

import { fetchCoursesAdmin } from '../../../modules/courses/actions';
import { loadTexts } from '../../../config/texts';

const rowsPerPage = 8;
const TEXT_KEY = 'components';

const AddCourses = props => {
  const texts = loadTexts(TEXT_KEY, props.locale);
  const [searchText, setSearchText] = React.useState('');
  const [page, setPage] = React.useState(0);

  const fetch = (p, search) => {
    props.fetchCourses({
      filter: {
        universities: [props.selectedUniversity],
        searchString: search,
      },
      page: { page: p + 1, limit: rowsPerPage },
    });
    setPage(p);
  };

  React.useEffect(() => {
    if (props.selectedUniversity)
      fetch(0);
  }, [props.selectedUniversity]);

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
    >
      <Card
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '500px',
          minHeight: '500px',
        }}
      >
        <TextField
          id="search_courses_text_field"
          label={texts.add_course.label.search}
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter')
              fetch(0, searchText);
          }}
          margin="dense"
          style={{ margin: 8, width: '98%' }}
        />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{texts.add_course.label.code}}</TableCell>
              <TableCell>{texts.add_course.label.title}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map(course => (
              <TableRow
                key={course._id}
                hover
                onClick={e => props.onSelect(course)}
                selected={props.selected.find(c => c._id === course._id)}
              >
                <TableCell>
                  {course.code}
                </TableCell>
                <TableCell>
                  {course.title}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[rowsPerPage]}
                page={page}
                count={props.count}
                onChangePage={() => {}}
                ActionsComponent={() => (
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <IconButton
                      onClick={() => fetch(0, searchText)}
                      disabled={page === 0}
                    >
                      <FirstPageIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => fetch(page - 1, searchText)}
                      disabled={page === 0}
                    >
                      <ArrowLeftIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => fetch(page + 1, searchText)}
                      disabled={page >= Math.ceil(props.count / rowsPerPage) - 1}
                    >
                      <ArrowRightIcon />
                    </IconButton>
                    <IconButton
                      onClick={() => fetch(Math.floor(props.count / rowsPerPage), searchText)}
                      disabled={page >= Math.ceil(props.count / rowsPerPage) - 1}
                    >
                      <LastPageIcon />
                    </IconButton>
                  </div>
                )}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Card>
    </Modal>
  );
};

AddCourses.propTypes = {
  onUpdate: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  count: get(state, 'courses.admin.data.count') || 0,
  locale: state.appState.locale,
  data: createSelector(
    state => get(state, 'courses.admin.data.courses') || [],
    courses => courses.map(course => ({
      _id: get(course, '_id'),
      code: `${get(course, 'subject')} ${get(course, 'number')}`,
      title: get(course, 'title'),
    }))
  )(state),
});

const mapDispatchToProps = dispatch => ({
  fetchCourses: params => dispatch(fetchCoursesAdmin(params)()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(AddCourses);



// WEBPACK FOOTER //
// ./src/app/components/user/AddCourses.js